import { render, staticRenderFns } from "./ProjectServices.vue?vue&type=template&id=ddb0f22c"
import script from "./ProjectServices.vue?vue&type=script&lang=ts"
export * from "./ProjectServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports